import ITNHomepage from '../features/homepage/ITNHomepage';
// import OfferPage from './OfferPage';
import BasketPage from './BasketPage';
import CheckoutPage from './CheckoutPage';
import TakeTour from './TakeTour';
import TrainingPage from './TrainingPage';
import {NotFound} from './NotFound';
import * as JobsPages from '../features/jobs/pages';
import * as MembersPages from '../features/members/pages';
import * as CoursesPages from '../features/training/courses/pages';
import * as WebinarsPages from '../features/training/webinars/pages';
import * as PodcastsPages from '../features/training/podcasts/pages';
import * as PodcastSeriesPage from '../features/training/podcasts/series';
import * as EventsPage from '../features/events/pages';
import MagazinePage from '../features/magazine/MagazinePage';
import * as ForumPages from '../features/forums/pages';
import * as PurchasesPages from '../../common/purchases';
import * as NetworkingPages from '../features/networking/pages';
import * as PromotionPages from "../features/promos";
import * as AccountSettings from '../features/account';
import * as Help from '../features/help';
import * as DocumentsPages from '../features/documents/pages';
import PaymentPage from "./PaymentPage";
import PaymentConfirmation from './PaymentConfirmation';
import RegistrationForm from './Registration';
import TermsPage from '../features/legal/TermsPage';
import DPTermsPage from '../features/legal/DPTermsPage';
import CookiesPage from '../features/legal/CookiesPage';
import PrivacyPage from '../features/legal/PrivacyPage';
import CvWritingPage from '../features/cvwriting/CvWritingPage';
import TestimonialsPage from '../features/testimonials/TestimonialsPage';
import Profile from '../features/profile/ProfilePage';
import JobsLayout from '../features/jobs/pages/JobsLayout';
import CMSPage from '../../common/CMS/CMSPage';
import CorporateOverviewPage from '../features/partnerships/CorporateOverviewPage';
import PartnersOverviewPage from '../features/partnerships/PartnersOverviewPage';
import PartnersCategoryPage from '../features/partnerships/PartnersCategoryPage';
import BrightTalkWebinarsPage from '../features/training/brightTalkWebinars/pages/BrightTalkWebinarsPage';
import AskAnExpertPage from '../features/askanexpert/AskAnExpertPage';
// Slices test page
import SlicesTestPage from '../features/slices-test-page/SlicesTestPage';
//Blogs
import BlogMainPage from '../features/blogs/BlogsMainPage';
import SingleArticlePage from '../features/blogs/SingleArticlePage';
import {StarsPage} from './StarsPage';
import {ContactPage} from './ContactPage';
import NewsPage from './NewsPage'

export {
    ITNHomepage,
    // OfferPage,
    BasketPage,
    NewsPage,
    CheckoutPage,
    TakeTour,
    TrainingPage,
    NotFound,
    JobsPages,
    CoursesPages,
    WebinarsPages,
    PodcastsPages,
    PodcastSeriesPage,
    EventsPage,
    MagazinePage,
    ForumPages,
    PurchasesPages,
    NetworkingPages,
    PromotionPages,
    PaymentPage,
    PaymentConfirmation,
    RegistrationForm,
    MembersPages,
    AccountSettings,
    Help,
    DocumentsPages,
    TermsPage,
    DPTermsPage,
    CookiesPage,
    BlogMainPage,
    SingleArticlePage,
    PrivacyPage,
    CvWritingPage,
    TestimonialsPage,
    Profile,
    JobsLayout,
    BrightTalkWebinarsPage,
    CMSPage,
    CorporateOverviewPage,
    PartnersOverviewPage,
    PartnersCategoryPage,
    AskAnExpertPage,
    SlicesTestPage,
    StarsPage,
    ContactPage
};



// WEBPACK FOOTER //
// src/client/components/site/pages/index.js